import { fromJS } from 'immutable';
import actionTypes from '../../actions/actionTypes';
import requestStatus from '../../constants/requestStatus';

const INIT_STATE = fromJS({
    status: requestStatus.INITIALIZED,
    error: null
});


const onGet = (state, action)       => state.set('status', requestStatus.REQUEST_PENDING)
                                            .set('error', '')

const onError = (state, action)     => state.set('status', requestStatus.REQUEST_ERROR)
                                            .set('error', action.payload.errorMessage)

const onSuccess = (state, action)   => fromJS({
    status: requestStatus.REQUEST_SUCCESS,
    error: '',
    ... action.payload.cliData
})

const cliDataReducer = (state = INIT_STATE, action) => {
    switch(action.type){
        case actionTypes.CLI_DATA_GET_REQUEST:
            return onGet(state, action);
        case actionTypes.CLI_DATA_GET_SUCCESS:
            return onSuccess(state, action);
        case actionTypes.CLI_DATA_GET_ERROR:
            return onError(state, action);
        default:
            return state
    }
}

export default cliDataReducer;